export const API_SERVER_ADDRESS = "https://brownfoldpaper-api.kaiznn.com";
export const IMAGE_BASE_URL = "https://kaiznn-bucket.s3.ap-south-1.amazonaws.com/";
export const CUSTOMER_ACCOUNT = "Kaiznn";
export const WS_SERVER_ADDRESS = 'wss://brownfoldpaper-api.kaiznn.com/ws/notifications/';